export type Theme = 'bosch' | 'pro' | 'diy' | 'dremel';
export type Mode = 'light' | 'dark';

export const THEMES: Theme[] = ['bosch', 'pro', 'diy', 'dremel'];
export const DEFAULT_THEME: Theme = 'bosch';
export const DEFAULT_MODE: Mode = 'light';

export const THEME_SUPPORTS_DARK: Record<Theme, boolean> = {
  bosch: true,
  pro: true,
  diy: true,
  dremel: false,
};

export const THEME_FONT_FAMILY: Record<Theme, string> = {
  bosch: '"Bosch Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  pro: '"Bosch Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  diy: '"Bosch Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  dremel: '"Avenir Next LT Pro", "Avenir Next", Avenir, system-ui, sans-serif',
};

export const LOCAL_STORAGE_MODE_KEY = 'jenny-color-mode';
